// NOTE: This value must stay in sync with LEFT_NAV_WIDTH in src/components/AppLayoutContainer/styles.ts
export const LEFT_NAV_WIDTH = 296;

const ACCOUNT_SETTINGS = 'Account settings';
const AD_MANAGEMENT = 'Ad management';
const ALERTS = 'Alerts';
const ANALYTICS = 'Analytics';
const BILLING = 'Billing';
const CONTACTS = 'Contacts';
const CONTACT_SUPPORT = 'Contact support';
const GO_TO_ZILLOW = 'Go to Zillow';
const HELP = 'Help';
const LEADS = 'Leads';
const MAINTENANCE = 'Maintenance';
const MESSAGES = 'Messages';
const ONBOARDING_TASKS = 'Onboarding tasks';
const PAYMENTS = 'Payments';
const POST_A_LISTING = 'Post a Listing';
const PROPERTIES = 'Properties';
const RENTAL_MANAGER = 'Rental Manager';
const RESOURCES = 'Resources';
const SECURITY_SETTINGS = 'Security settings';
const SIGN_OUT = 'Sign out';
const USER_MANAGEMENT = 'User management';

// header titles
export const HeaderTitles = {
  accountSettings: ACCOUNT_SETTINGS,
  adManagement: AD_MANAGEMENT,
  alerts: ALERTS,
  analytics: ANALYTICS,
  backToBrand: GO_TO_ZILLOW,
  billing: BILLING,
  contactSupport: CONTACT_SUPPORT,
  help: HELP,
  leadManagement: LEADS,
  leads: CONTACTS,
  maintenanceTracker: MAINTENANCE,
  messages: MESSAGES,
  mfhResources: RESOURCES,
  myProperties: PROPERTIES,
  onboardingTasks: ONBOARDING_TASKS,
  payments: PAYMENTS,
  postAListing: POST_A_LISTING,
  rentalManager: RENTAL_MANAGER,
  resources: RESOURCES,
  securitySettings: SECURITY_SETTINGS,
  signOut: SIGN_OUT,
  userManagement: USER_MANAGEMENT,
} as const;

export const CSTriggerSourceFromHeaderTitlesMap: Record<string, string> = {
  [ACCOUNT_SETTINGS]: 'account_settings',
  [ALERTS]: 'alerts',
  [BILLING]: 'billing_link',
  [GO_TO_ZILLOW]: 'go_to_zillow_link',
  [HELP]: HELP.toLowerCase(),
  [LEADS]: 'leads',
  [MESSAGES]: MESSAGES.toLowerCase(),
  [ONBOARDING_TASKS]: 'onboarding_tasks',
  [PAYMENTS]: 'payments',
  [PROPERTIES]: PROPERTIES.toLowerCase(),
  [RESOURCES]: RESOURCES.toLowerCase(),
  [SIGN_OUT]: 'sign_out',
  [USER_MANAGEMENT]: 'user_management_link',
  [AD_MANAGEMENT]: 'ad_management',
};
